import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Locale from '../locales/en/financialStrength';
import Goals from './Goals';
import WheelChart from '../images/financial-strength-pie-chart-numbered.svg';

const FinancialStrength = ({ setGoalsView }) => {
  const datapoint = useRef(null);
  const [datapointVisibility, setDatapointVisibility] = useState(false);

  const findDataVisibility = () => {
    if (!datapoint) {
      setDatapointVisibility(false);
      return;
    }
    const rect = datapoint.current.getBoundingClientRect();
    const bool = !(rect.y > window.innerHeight || rect.y < (rect.height * -1));
    setDatapointVisibility(bool);
  };

  useEffect(() => {
    window.addEventListener('scroll', findDataVisibility);

    return () => window.removeEventListener('scroll', findDataVisibility);
  }, []);

  return (
    <div id="financial-strength">
      <div className="bg-wrapper-vision">
        <div className="vision">
          <h1>
            {Locale.title}
          </h1>
          <div className="text-box">
            {Locale.visionTitle}
          </div>
          <h3>
            {Locale.visionSubHeader}
          </h3>
          <div
            className="vision-body"
            dangerouslySetInnerHTML={{ __html: Locale.visionBody }}
          />
        </div>
      </div>
      <div className="bg-wrapper-visual-datapoint">
        <div ref={datapoint} className="visual-datapoint">
          <div
            className={`data ${datapointVisibility ? 'animated' : ''}`}
            dangerouslySetInnerHTML={{ __html: Locale.datapoint }}
          />
          <div className="visual">
            <img src={WheelChart} className="wheel-chart" alt="wheel chart" />
          </div>
        </div>
      </div>
      <Goals
        items={Locale.goals}
        setGoalsView={setGoalsView}
      />
    </div>
  );
};

FinancialStrength.propTypes = {
  setGoalsView: PropTypes.func.isRequired
};

export default FinancialStrength;
